export default "__VITE_ASSET__12826919__"